import { all, call, put } from 'redux-saga/effects';
import TripsClient from '../../api/TripsClient';
import { setOngoingTripReceiptsLoading, setOngoingTripReceipts } from '../../redux/billing/actions';
import { messagesShow } from '../../redux/messages/actions';

export function* getOngoingTripReceiptsSaga({ payload: journeysIds }) {
    try {
        yield put(setOngoingTripReceiptsLoading(true));

        const requests = journeysIds.map(tripId => call(TripsClient.getOngoingTripsReceipts, tripId));
        const receipts = yield all(requests);

        const ongoingTripsReceipts = receipts.reduce((acc, receiptsForTrip, index) => {
            const tripId = journeysIds[index];

            const namedReceipts = receiptsForTrip.reduce((receiptMap, receipt, receiptIndex) => {
                const map = receiptMap || {};
                const receiptKey = receipt.id || `receipt${receiptIndex}`;
                map[receiptKey] = receipt;
                return map;
            }, {});

            acc[tripId] = namedReceipts;
            return acc;
        }, {});

        yield put(setOngoingTripReceipts(ongoingTripsReceipts));
        return ongoingTripsReceipts;
    } catch (error) {
        console.error('Error fetching ongoing trip receipts:', error);
        yield put(messagesShow('billingPage.ongoingTripsPage.notifications.receiptsFetchError', 'error'));
        return {};
    } finally {
        yield put(setOngoingTripReceiptsLoading(false));
    }
}
